import axios from 'axios';

export default {
  created() {
    this._abortControllers = new Map();
  },
  beforeUnmount() {
    if (!this._abortControllers) return;
    for (const controller of this._abortControllers.values()) {
      controller.abort();
    }
    this._abortControllers.clear();
  },
  methods: {
    _renewAbortSignal(name = 'default') {
      if (!this._abortControllers) this._abortControllers = new Map();
      this._abortControllers.get(name)?.abort();
      const controller = new AbortController();
      this._abortControllers.set(name, controller);
      return controller.signal;
    },
    _isAborted(error) {
      return axios.isCancel(error);
    },
  },
};
